export const buildEvaluateMeasureParameters = (
    periodStart: string,
    periodEnd: string,
    serviceId?: string
) => {
    const fhirEndpointAddress = process.env.REACT_APP_FHIR_URL ?? "fhir";
    const parameter: any[] = [
        {
            name: "periodStart",
            valueDate: periodStart
        },
        {
            name: "periodEnd",
            valueDate: periodEnd
        }
    ];

    for (const name of ["dataEndpoint", "terminologyEndpoint", "contentEndpoint"]) {
        parameter.push({
            name,
            resource: {
                resourceType: "Endpoint",
                status: "active",
                connectionType: {
                    system: "http://terminology.hl7.org/CodeSystem/endpoint-connection-type",
                    code: "hl7-fhir-rest"
                },
                payloadType: [{
                    coding: [{
                        system: "http://terminology.hl7.org/CodeSystem/endpoint-connection-type",
                        code: "hl7-fhir-rest",
                        display: "HL7 FHIR"
                    }]
                }],
                address: fhirEndpointAddress,
                header: ["Content-Type: application/json"]
            }
        });
    }

    if (serviceId) {
        parameter.push({
            name: "parameters",
            resource: {
                resourceType: "Parameters",
                parameter: [
                    {
                        name: "serviceId",
                        valueString: serviceId
                    }
                ]
            }
        });
    }

    return {
        resourceType: "Parameters",
        parameter
    };
};
